export default "/_next/static/chunks/fonts/RobotoMono-Regular-c460abd4bbf649cf4e4bb291f5020575.woff2";